import React, { useState } from "react";
import Card from "../components/card";
import "./Adoption.css";

const image = require('../assets/search.png');

function Adoption({ animal }) {
    const [displayAnimals, setDisplay] = useState(animal);
    const [searchInput, setSearchInput] = useState('');

    const handleSearch = () => {
        const filteredAnimals = animal.filter(a =>
            (typeof a.name === 'string' && a.name.toLowerCase().includes(searchInput.toLowerCase())) ||
            (typeof a.breed === 'string' && a.breed.toLowerCase().includes(searchInput.toLowerCase()))
        );
        setDisplay(filteredAnimals);
    };

    return (
        <>
            <div className="adoptionPage">
                <br/>
                <h1>Our Animals</h1>
                <br/>
                <p>Meet our lovely animals available for adoption. Each one has a unique story and is looking for a loving home.</p>
                <p>Browse through the list and find your new best friend today!</p>
                <div className="searchContainer">
                    <input
                        type="text"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        placeholder="Search By 'Name' or 'Breed'"
                        className="searchBar"
                    />
                    <button onClick={handleSearch} className="searchBtn"><img className="searchIcon" src={image}></img></button>
                </div>
                <div className="adoptionGrid">
                    {displayAnimals.map(animal => <Card animal={animal} key={animal.id} />)}
                </div>
            </div>
        </>
    );
};

export default Adoption;
